'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _SelectDropDownIndicator = require('./SelectDropDownIndicator');

var _SelectDropDownIndicator2 = _interopRequireDefault(_SelectDropDownIndicator);

var _SelectInputTags = require('./SelectInputTags');

var _SelectInputTags2 = _interopRequireDefault(_SelectInputTags);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var KEYS_TO_OPEN = [' ', // Space key
'ArrowDown', 'ArrowUp'];

var SelectInputController = function (_Component) {
  _inherits(SelectInputController, _Component);

  function SelectInputController(props) {
    _classCallCheck(this, SelectInputController);

    var _this = _possibleConstructorReturn(this, (SelectInputController.__proto__ || Object.getPrototypeOf(SelectInputController)).call(this, props));

    _this.onChange = function (event) {
      _this.props.openMenu();
      _this.props.onInputChange(event.target.value);
    };

    _this.getDisplayValue = function () {
      var _this$props = _this.props,
          selectedOptions = _this$props.selectedOptions,
          filter = _this$props.filter,
          displayKey = _this$props.displayKey,
          multiple = _this$props.multiple;

      if (filter === null && !multiple && selectedOptions.length) {
        return selectedOptions[0][displayKey];
      } else {
        return filter || '';
      }
    };

    _this.getContainerClasses = function () {
      var focused = _this.state.focused;
      var _this$props2 = _this.props,
          selectedOptions = _this$props2.selectedOptions,
          disabled = _this$props2.disabled,
          menuIsOpen = _this$props2.menuIsOpen;

      var className = 'SelectInputController';
      if (disabled) {
        return className + ' disabled';
      }
      className += focused ? ' active' : '';
      className += selectedOptions.length && !menuIsOpen ? ' hasValue' : '';
      return className;
    };

    _this.onContainerClick = function () {
      _this.input.focus();
    };

    _this.onInputBlur = function () {
      _this.setState({ focused: false });
    };

    _this.onInputFocus = function () {
      if (_this.props.disabled) {
        return;
      }
      _this.props.openMenu();
      _this.setState({ focused: true });
    };

    _this.handleInputKeyDown = function (event) {
      if (_this.props.menuIsOpen) {
        return;
      }
      if (KEYS_TO_OPEN.includes(event.key)) {
        event.preventDefault();
        _this.props.openMenu();
      }
    };

    _this.setInputRef = function (node) {
      _this.input = node;
    };

    _this.input = null;

    _this.state = {
      focused: false
    };
    return _this;
  }

  _createClass(SelectInputController, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          multiple = _props.multiple,
          searchPlaceholder = _props.searchPlaceholder,
          closedPlaceholder = _props.closedPlaceholder,
          menuIsOpen = _props.menuIsOpen,
          disabled = _props.disabled,
          selectedOptions = _props.selectedOptions,
          displayKey = _props.displayKey,
          stylingKey = _props.stylingKey,
          onRemove = _props.onRemove;

      return _react2.default.createElement(
        'div',
        {
          className: this.getContainerClasses(),
          onClick: this.onContainerClick
        },
        _react2.default.createElement(_SelectInputTags2.default, {
          multiple: multiple,
          selectedOptions: selectedOptions,
          displayKey: displayKey,
          onRemove: onRemove,
          stylingKey: stylingKey
        }),
        _react2.default.createElement('input', {
          className: 'SelectInputController-input',
          ref: this.setInputRef,
          disabled: disabled,
          type: 'text',
          onChange: this.onChange,
          value: this.getDisplayValue(),
          placeholder: menuIsOpen ? searchPlaceholder : closedPlaceholder,
          onBlur: this.onInputBlur,
          onFocus: this.onInputFocus,
          onKeyDown: this.handleInputKeyDown
        }),
        _react2.default.createElement(_SelectDropDownIndicator2.default, { menuIsOpen: menuIsOpen })
      );
    }
  }]);

  return SelectInputController;
}(_react.Component);

SelectInputController.propTypes = {
  multiple: _propTypes2.default.bool.isRequired,
  disabled: _propTypes2.default.bool.isRequired,
  filter: _propTypes2.default.string,
  openMenu: _propTypes2.default.func.isRequired,
  menuIsOpen: _propTypes2.default.bool.isRequired,
  closedPlaceholder: _propTypes2.default.string.isRequired,
  searchPlaceholder: _propTypes2.default.string.isRequired,
  onInputChange: _propTypes2.default.func.isRequired,
  onRemove: _propTypes2.default.func.isRequired
};

SelectInputController.defaultProps = {
  filter: null,
  disabled: false
};

exports.default = SelectInputController;


//////////////////
// WEBPACK FOOTER
// ../frontend-component-library/build/Components/FormInputs/Select/SelectInputController.js
// module id = 542
// module chunks = 0